export const APPLY_CURRENT_USER_PROFILE_OF_INTRANET = "applyCurrentUserProfileOfIntranet";
export const FETCH_PROFILE = "fetchProfile";
export const FETCH_PROFILES_FOR_USER_UIDS = "fetchProfilesForUserUids";
export const UPDATE_PROFILE_IMAGE = "updateProfileImage";
export const DELETE_PROFILE_IMAGE = "deleteProfileImage";
